<c-smart-table
  [activePage]="1"
  [columnSorter]="true"
  [columns]="PaymentHistoryColumns"
  [itemsPerPageSelect]="true"
  tableFilterPlaceholder="Type Here"
  [itemsPerPage]="10"
  [items]="PaymentHistoryData"
  [sorterValue]="{ column: 'name', state: 'asc' }"
  [tableFilter]="false"
  tableFilterLabel="  Search:"
  [tableProps]="{ hover: true, responsive: true }"
  [tableBodyProps]="{ align: 'middle' }"
  clickableRows
  header
  pagination
  [loading]="Loading"
  (rowClick)="OpenInvoicePage($event.item)"
  >
  <ng-template
    cTemplateId="tableData"
    let-columnName="columnName"
    let-item="item"
    let-tdContent="tdContent"
  >
    <td>
      <ng-container [ngSwitch]="columnName">
        <ng-container *ngSwitchCase="'Actions'" class="py-2">
          <button
            (click)="toggleDetails(item._id)"
            cButton
            color="primary"
            size="sm"
            variant="outline"
          >
            Actions
          </button>
        </ng-container>
        <ng-container *ngSwitchCase="'invoiceDueDate'" class="py-2">
          {{ tdContent | date : "MM/dd/yyyy" }}
        </ng-container>
        <ng-container *ngSwitchCase="'invoiceDate'" class="py-2">
          {{ tdContent | date : "MM/dd/yyyy" }}
        </ng-container>
        <ng-container *ngSwitchCase="'paymentDate'" class="py-2">
          {{ item.isPaid ? (tdContent | date : "MM/dd/yyyy") : " " }}
        </ng-container>
        <ng-container *ngSwitchCase="'isPaid'" class="py-2">
          {{ tdContent ? "Paid" : "Unpaid" }}
        </ng-container>
        <ng-container *ngSwitchCase="'productName'" class="py-2">
          {{ item.invoice_Details[0]?.productName }}
        </ng-container>
        <ng-container *ngSwitchCase="'Amount'" class="py-2">
          <div class="text-end">
           
            <span *ngIf="!item.o_IsBillToClient"> {{ item.totalAmount - item.discountAmount - item.srvDiscountAmount | currency: "USD" }}</span>
            <span *ngIf="item.o_IsBillToClient">  {{ item.totalAmount  | currency: "USD" }}</span>
          
          </div>
        </ng-container>

        <ng-container *ngSwitchDefault>
          {{ tdContent }}
        </ng-container>
      </ng-container>
    </td>
  </ng-template>
</c-smart-table>
